export const SEARCH_BY_STORE = "STORES/SEARCH_BY_STORE";
